import { createSelector } from "reselect";
import { createMakeSelectCurrentPage } from "lib/providers/pagination-provider/selectors";
import { makeSelectEntityStatuses } from "entities/entity_status/selectors";
import { makeSelectTranslation } from "../translation/selectors";
import { makeSelectStringSource } from "../stringResources/selectors";

const selectEntity = state => state.entities.alg_criteria_usage;
const selectEntityData = state =>
  state.entities.alg_criteria_usage
    ? state.entities.alg_criteria_usage.data
    : [];

export const makeSelectCriteriaUsage = paginationKey =>
  createSelector(
    [
      selectEntityData,
      createMakeSelectCurrentPage(paginationKey)(),
      makeSelectEntityStatuses(),
      makeSelectStringSource(),
      makeSelectTranslation()
    ],
    (substate, page, statuses, resources, translations) => {
      if (!paginationKey) {
        return substate;
      }

      if (page.length > 0)
        return page
          .map(id => {
            if (!substate[id]) {
              return null;
            }

            const criteriaUsage = { ...substate[id] };
            criteriaUsage.entity_status =
              statuses[criteriaUsage.entity_status.id];
            for (let string of resources) {
              if (string.id === criteriaUsage.name)
                criteriaUsage.string_resources = string;
            }
            const newTranslations = [];
            for (let translation of criteriaUsage.string_resources
              .translations) {
              newTranslations.push(translations[translation.id]);
            }
            criteriaUsage.string_resources.translations = newTranslations;

            return criteriaUsage;
          })
          .filter(row => row);
    }
  );

export const makeSelectCriteriaUsageLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
  });

export const makeSelectCriteriaUsageError = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.error;
  });
